import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MdDialog } from "@angular/material";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { saveAs } from "file-saver";
import { get } from "lodash";

import { environment } from "../../environments/environment";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";
import { PrintService, ParticipationFormService } from "../shared";
const ROLES = require("../../../../server/shared/constants/role.constant");

@Component({
  selector: "home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  public isOrderEnabled: boolean;
  public vendor$: Observable<any>;
  profile$: Observable<any>;
  currentUser: any;

  constructor(
    private store: Store<any>,
    private router: Router,
    private dialog: MdDialog,
    private printService: PrintService,
    private participationFormService: ParticipationFormService
  ) {
    this.vendor$ = this.store.select("VENDOR_REDUCER");
  }

  ngOnInit() {
    this.profile$ = this.store.select("PERSON_REDUCER");

    this.profile$.subscribe((s) => {
      this.currentUser = s.user;
    });
  }

  getLink(): string {
    return environment.GROUP_TRACKABLES_URL;
  }

  getEnroll() {
    if (
      confirm(
        'NOTE: Enrollment forms should only be completed once by every participating unit. If your unit has already submitted an enrollment form, go to the "Status" page, select your unit and use the "Amend Form" feature to make any necessary changes, including updates to contacts/purchasers/supervisors or to add/remove employees. If your unit is new to the program or is splitting into multiple, smaller groups, please proceed to the enrollment form.'
      )
    ) {
      this.router.navigate(["participationForm"]);
    }
  }

  openDialog() {
    this.dialog.open(ConfirmationDialogComponent, {
      width: "600px",
    });
  }

  isUcopAdmin() {
    return this.currentUser && this.currentUser.role === ROLES.ROLE_UCOP_ADMIN;
  }

  isAppAdmin() {
    return this.currentUser && this.currentUser.role === ROLES.ROLE_APP_ADMIN;
  }

  canManageStuckPrograms() {
    return this.isAppAdmin() || this.isUcopAdmin();
  }

  exportEmployeePayrollTitles() {
    this.participationFormService.exportEmployeePayrollTitles().then((data) => {
      const filename = `Slip-resistant_Employee Payroll Titles_${new Date()
        .toLocaleDateString()
        .replace(/\//g, "_")}.xlsx`;

      this.printService
        .printXlsx({
          filename,
          data: [
            {
              name: "All Employee",
              data: get(data, "employeePayrollTitles"),
            },
            {
              name: "Unique Payroll Title",
              data: get(data, "uniquePayrollTitles"),
            },
          ],
        })
        .then((blob) => saveAs(blob, filename));
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/home/home.component.ts